/**
 * Determines whether the booking is configured to use Stripe Connect
 * as its payment processor.
 */
export function canUseStripeConnect(bookingData: {
  paymentProcessor?: string;
  venue?: unknown;
}): boolean {
  return !!bookingData.paymentProcessor && !!bookingData.venue && bookingData.paymentProcessor === "stripe_connect";
}

const PAYMENT_DETAIL_KEYS = [
  "payment_ref",
  "currency",
  "processor",
  "card_type",
  "card_last_four",
  "card_funding",
  "created_date",
  "venue_id",
  "venue_group_id",
] as const;

/**
 * Extract only the essential payment fields from a raw payment processor
 * response (e.g. FreedomPay) to avoid 413 payload-too-large errors when
 * forwarding to the Collins API. Returns `undefined` if the input is not
 * a usable object.
 */
export function extractPaymentDetails(paymentResponse: unknown): Record<string, unknown> | undefined {
  if (!paymentResponse || typeof paymentResponse !== "object") {
    return undefined;
  }

  const payment = paymentResponse as Record<string, unknown>;
  const paymentModel: Record<string, unknown> = {};

  for (const key of PAYMENT_DETAIL_KEYS) {
    if (payment[key]) {
      paymentModel[key] = payment[key];
    }
  }
  if (payment.amount !== undefined) paymentModel.amount = payment.amount;

  return Object.keys(paymentModel).length > 0 ? paymentModel : undefined;
}
